module.exports = __webpack_public_path__ + "img/user3.d3aa8dc5.jpg";